import { fetchCustomEquipmentTypes, resolveIconUrl } from "./customEquipmentTypesService";

// Store em escopo de módulo (singleton): o catálogo de equipamentos personalizados é
// global, mas cada circuito editado monta seu próprio <DiagramaEquipamentos/> (várias
// abas ficam montadas ao mesmo tempo, ver CLAUDE.md). Sem esse compartilhamento, criar um
// tipo personalizado numa aba só atualizava o estado local daquela aba — as demais só
// enxergavam a novidade depois de um F5. Com o cache/listeners aqui fora do React, todo
// componente inscrito via useSyncExternalStore recebe o mesmo catálogo e é notificado
// junto quando qualquer aba cria/edita/exclui um tipo.
let cache = [];
let loaded = false;
let inFlight = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

const carregarComIcones = async () => {
  const lista = await fetchCustomEquipmentTypes();
  return Promise.all(
    (lista || []).map(async (item) => ({
      ...item,
      iconUrl: await resolveIconUrl(item?.id).catch(() => null),
    })),
  );
};

export const subscribeCustomEquipmentTypes = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getCustomEquipmentTypesSnapshot = () => cache;

// Garante que o catálogo tenha sido buscado ao menos uma vez; chamadas concorrentes de
// várias abas montando ao mesmo tempo reaproveitam a mesma requisição em andamento.
export const ensureCustomEquipmentTypesLoaded = () => {
  if (loaded || inFlight) return inFlight;
  inFlight = carregarComIcones()
    .then((lista) => {
      cache = lista;
      loaded = true;
      notify();
    })
    .catch((error) => {
      console.error("Erro ao buscar equipamentos personalizados:", error);
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
};

// Rebusca o catálogo e notifica TODAS as abas inscritas — chamar após criar/editar/excluir
// um tipo personalizado, para que o impacto seja imediato em todo o painel, não só na aba de origem.
export const refreshCustomEquipmentTypes = async () => {
  try {
    cache = await carregarComIcones();
    loaded = true;
    notify();
  } catch (error) {
    console.error("Erro ao buscar equipamentos personalizados:", error);
  }
};
